import React, { ReactNode, useEffect, useState } from 'react';
import { useInView } from 'Utils/hooks/useInView';
import { scheduleStaggeredMount } from 'Utils/performance/mountQueue';

type Props = {
  children: ReactNode;
  placeholder?: ReactNode;
  rootMargin?: string;
  className?: string;
  staggerMount?: boolean;
};

const LazyMountOnVisible = function LazyMountOnVisible(props: Props) {
  const {
    children,
    placeholder = null,
    rootMargin = '250px 0px',
    className,
    staggerMount = true,
  } = props;
  const { ref, inView } = useInView({ rootMargin, triggerOnce: true });
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    if (!inView || mounted) return undefined;

    if (!staggerMount) {
      setMounted(true);
      return undefined;
    }

    let cancelled = false;
    scheduleStaggeredMount(() => {
      if (!cancelled) setMounted(true);
    });
    return () => {
      cancelled = true;
    };
  }, [inView, mounted, staggerMount]);

  return (
    <div ref={ref} className={className}>
      {mounted ? children : placeholder}
    </div>
  );
};

export default LazyMountOnVisible;
